"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = markRanges;

var _lodash = require("lodash");

var _Term = _interopRequireDefault(require("../Term"));

var _Range = _interopRequireDefault(require("../Range"));

var _constants = require("../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function markTermRanges(term, ranges, rangesFiltered) {
  if (Array.isArray(term)) {
    // eslint-disable-next-line no-use-before-define
    markRanges(term, ranges);
  } else {
    if (!(term instanceof _Term["default"])) {
      throw new Error('markTermRanges expects a term');
    }

    if (!Array.isArray(ranges)) {
      throw new Error('markTermRanges expects an array of ranges');
    }

    var lRanges = rangesFiltered ? ranges : (0, _lodash.filter)(ranges, function (range) {
      return range instanceof _Range["default"] && range.isValid;
    });
    var found = false;

    if (term.isValidTime) {
      lRanges.forEach(function (range) {
        if (range.intersects(term) || term.start <= range.start && term.end >= range.start) {
          term.set("range:" + range.name, true);
          found = true;
        }
      });
      if (!found) return;
    }

    switch (term.type) {
      case _constants.TYPE_TERM:
        markTermRanges(term.value, lRanges, true);
        break;

      case _constants.TYPE_ARRAY:
        // eslint-disable-next-line no-use-before-define
        markRanges(term.value, lRanges, true);
        break;

      default: // not a recursing term

    }
  }
}
/**
 * markRanges changes the properties of the input - it doesn't create/rearrange terms.
 *
 * It goes through each range and if the term contains the range, it marks it.
 * Note it is a recursive operation - it marks any container that falls in a range, AND
 * it goes through the children and marks them too.
 *
 * @param source {Array || Term}
 * @param ranges {[Range]}
 * @returns void
 */


function markRanges(source, ranges) {
  if (!(Array.isArray(source) || source instanceof _Term["default"])) {
    throw new Error('markRanges expects source to be a term and an array');
  }

  if (!Array.isArray(ranges)) {
    throw new Error('markRanges expects ranges to be an array');
  }

  var lRanges = (0, _lodash.filter)(ranges, function (range) {
    return range instanceof _Range["default"] && range.isValid;
  });

  if (source instanceof _Term["default"]) {
    markTermRanges(source, lRanges, true);
  } else {
    source.forEach(function (term) {
      switch (_Term["default"].typeOf(term)) {
        case _constants.TYPE_ARRAY:
          markRanges(term, lRanges);
          break;

        case _constants.TYPE_TERM:
          markTermRanges(term, lRanges, true);
          break;

        default:
          console.log('unknown type found in markRanges series');
      }
    });
  }
}